import React from 'react';
import { JSONTree } from 'react-json-tree';

export default function MyJsonViewer({data}) {
    return (
        <JSONTree
            data={data}
        />
    );
}
